'use client';

import { createContext, Dispatch, SetStateAction } from 'react';

type AuthProviderContextProps = {
  returnTo: string | null;
  setReturnTo: Dispatch<SetStateAction<string | null>>;
} | null;

export const AuthProviderContext = createContext<AuthProviderContextProps>(null);
